import { createContext, useContext } from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const DrawerContext = createContext({});
const useDrawerContext = /* @__PURE__ */ __name(() => useContext(DrawerContext), "useDrawerContext");

export { DrawerContext, useDrawerContext };
//# sourceMappingURL=drawer-context.js.map
